<template>
  <!-- Główny kontener dla widoku VMS (tablica znaków zmiennej treści) -->
  <div class="content-container">
    <!-- Panel filtrów danych VMS (lewa kolumna) -->
    <filter-vms-data />
    <div class="content-wrap">
      <!-- Pasek akcji nad listą. Stan znaków pochodzi ze snapshotu zbieranego w tle, więc operator musi mieć
           sposób na wymuszenie odczytu na żywo - bez tego jedynym sposobem było przeładowanie strony. -->
      <div class="vms-toolbar">
        <button
          class="btn-download"
          :disabled="vmsStore.isLoading"
          @click="refreshAll()"
        >
          {{ t('vms-refresh') }}
        </button>
      </div>
      <!-- Lista grup VMS (przekazuje statusy, opisy i stacje grup jako propsy) -->
      <vms-list 
        :group-statuses="vmsStore.groupStatuses"
        :group-descriptions="vmsStore.groupDescriptions"
        :group-locations="vmsStore.groupLocations"
      />
    </div>
  </div>
</template>

<script>
// Import wymaganych komponentów i Pinia Store
import VmsList from "@/components/Vms";
import { useVmsStore } from "@/stores/vms";
import FilterVmsData from "@/components/FilterVmsData.vue";

export default {
  name: "VmsView",
  components: {
    VmsList,           // Komponent listy znaków VMS
    FilterVmsData,     // Panel boczny z filtrami
  },
  setup() {
    // Ładowanie Pinia store z danymi VMS (statusy, opisy, stacje)
    const vmsStore = useVmsStore();
    // Store używany do przekazania statusów i opisów do komponentu VmsList
    return { vmsStore };
  },
  methods: {
    /**
     * Wymusza ponowne pobranie stanu wszystkich grup, z odpytaniem tablic na żywo.
     *
     * Operacja kosztowna - czas odpowiedzi jest sumą timeoutów wszystkich znaków - dlatego jest świadomym
     * działaniem operatora, a nie automatem.
     */
    refreshAll() {
      this.vmsStore.loadData({ force: true, fresh: true });
    },
  },
};
</script>

<style scoped>
/* Główne tło widoku VMS */
.content-container {
  background-color: var(--surface-secondary);
}

/* Pasek akcji nad listą grup */
.vms-toolbar {
  display: flex;
  justify-content: flex-end;
  padding: var(--spacing-lg) var(--spacing-lg) 0;
}

.vms-toolbar .btn-download {
  min-height: var(--control-height-sm);
  padding: 0 var(--spacing-lg);
  background-color: var(--surface-primary);
  border: 1px solid var(--border-strong);
  border-radius: var(--control-radius);
  color: var(--text-primary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-caps);
  cursor: pointer;
}

/* Stylowanie przycisków i akcji (część wspólnego stylu aplikacji) */

/* Przyciski typu "dalej" */
.btn-next {
  margin-right: 50px;
  padding: 8px 40px 8px 8px;
  position: relative;
  color: var(--text-secondary);
}
.btn-next:hover {
  color: var(--text-primary);
}
/* Sekcja akcji (dół/ góra) */
.actions, .actions-down {
  background-color: var(--surface-primary);
  width: 100%;
}

.actions .btn-prev, .actions-down .btn-prev {
  margin-left: 30px;
  padding: 8px 8px 8px 45px;
  position: relative;
  color: var(--text-secondary);
}
.actions .btn-prev:hover, .actions-down .btn-prev:hover {
  color: var(--text-primary);
}
.actions-down {
  margin-top: 2rem !important;
}
</style>
